import { render } from "./CreditRequestCreate.vue?vue&type=template&id=09b23b86&scoped=true"
import script from "./CreditRequestCreate.vue?vue&type=script&lang=js"
export * from "./CreditRequestCreate.vue?vue&type=script&lang=js"

import "./CreditRequestCreate.vue?vue&type=style&index=0&id=09b23b86&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b23b86"]])

export default __exports__